/**
*
* Payments Login
*
*/

import React, { PureComponent } from 'react';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';
import Container from '../../components/Container';
import {
  selectLoggedIn,
  getDefaultError,
  isLoading,
} from '../HeaderContainer/selectors';
import { constants } from '../../devUtils';
import LoginPage from '../LoginPage';
import Loader from '../../components/Loader';
import { HelmetWrapper } from '../../components';
import endPoints from '../../config/endPoints';
import theme from '../../theme';

const StyledPaymentsLogin = styled.section`
  .zaggle-logo {
    width: 150px;
    object-fit: contain;
  }
  @media (max-width: ${theme.breakpoints[1]}) {
    .zaggle-logo {
      width: 200px;
    }
    .mb-center{
      text-align: center;
    }
  };
`;

class Payments extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      isLoggedIn,
      apiResonse,
      isLoadingStatus,
      history,
      location,
    } = this.props;
    if (isLoggedIn) {
      return <Redirect to={constants.LINK_PAY_BALANCE} />;
    } else if (isLoadingStatus) {
      return <Loader />;
    }
    return (
      <StyledPaymentsLogin>
        <HelmetWrapper location={location} />
        <Container>
          <Row type="flex" align="stretch" justify="center" gutter={[20, 20]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-t-5 mb-center">
              <img
                src={endPoints.ZAGGLE_LOGO.URL}
                alt={endPoints.ZAGGLE_LOGO.ALT}
                className="zaggle-logo"
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="margin-t-5">
              <LoginPage
                apiResonse={apiResonse}
                isLoaderRequired
                history={history}
              />
            </Col>
          </Row>
        </Container>
      </StyledPaymentsLogin>
    );
  }
}

Payments.propTypes = {
  isLoggedIn: PropTypes.bool,
  apiResonse: PropTypes.object,
  isLoadingStatus: PropTypes.bool,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

Payments.defaultProps = {
  isLoggedIn: false,
  apiResonse: {},
  isLoadingStatus: false,
};

const mapStateToProps = createStructuredSelector({
  isLoggedIn: selectLoggedIn(),
  apiResonse: getDefaultError(),
  isLoadingStatus: isLoading(),
});

const component = connect(mapStateToProps)(Payments);
export default component;



// WEBPACK FOOTER //
// client/containers/ManageZaggleCard/payments.js